module.exports = __webpack_public_path__ + "static/media/compare-vehicles-icon.12b5282f.svg";